import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, unref as _unref, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-37c29b6c"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Rent a Unit", -1))
const _hoisted_2 = ["onSubmit"]
const _hoisted_3 = { key: 1 }
const _hoisted_4 = {
  key: 0,
  class: "form-field"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Customer", -1))
const _hoisted_6 = ["value"]
const _hoisted_7 = { class: "form-field" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "unit_id" }, "Unit Type", -1))
const _hoisted_9 = ["value", "disabled"]
const _hoisted_10 = {
  key: 1,
  class: "form-field"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "unit_id" }, "Unit", -1))
const _hoisted_12 = {
  key: 0,
  class: "form-field"
}
const _hoisted_13 = ["disabled"]
const _hoisted_14 = ["value"]
const _hoisted_15 = { key: 2 }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "unit_id" }, "Plan", -1))
const _hoisted_17 = ["value"]
const _hoisted_18 = { key: 3 }
const _hoisted_19 = { class: "form-field" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "customAmount" }, "Custom Rate", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_22 = {
  key: 4,
  class: "form-field"
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "unit_id" }, "Discount Plans", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: null }, "No discount", -1))
const _hoisted_25 = {
  key: 0,
  value: null,
  disabled: ""
}
const _hoisted_26 = ["value"]
const _hoisted_27 = {
  key: 5,
  class: "form-field"
}
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Gate Access Code", -1))
const _hoisted_29 = {
  key: 6,
  class: "form-field"
}
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", { style: {"margin-bottom":"25px"} }, [
  /*#__PURE__*/_createElementVNode("b", null, "Note"),
  /*#__PURE__*/_createTextVNode(": In order to rent a unit, a customer is "),
  /*#__PURE__*/_createElementVNode("b", null, "required"),
  /*#__PURE__*/_createTextVNode(" to sign up for an account. If they don't have an account, go to their profile and click \"Edit profile\"")
], -1))
const _hoisted_31 = [
  _hoisted_30
]
const _hoisted_32 = {
  key: 7,
  class: "form-field"
}
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Invoice Period", -1))
const _hoisted_34 = { value: "monthly" }
const _hoisted_35 = /*#__PURE__*/_createTextVNode(" Monthly - Prorated ")
const _hoisted_36 = /*#__PURE__*/_createTextVNode(" (Facility Default)")
const _hoisted_37 = { value: "anniversary" }
const _hoisted_38 = /*#__PURE__*/_createTextVNode(" Anniversary - Not Prorated ")
const _hoisted_39 = /*#__PURE__*/_createTextVNode(" (Facility Default)")
const _hoisted_40 = { class: "form-field" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Insurance", -1))
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: null }, "No Coverage", -1))
const _hoisted_43 = ["value"]
const _hoisted_44 = ["onClick"]
const _hoisted_45 = { class: "form-field" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "unit_id" }, "Move-in Date", -1))
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { style: {"text-align":"left"} }, "Alternate Contact Information", -1))
const _hoisted_48 = {
  key: 0,
  class: "form-field"
}
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "unit_id" }, "Description:", -1))
const _hoisted_50 = { class: "form-field" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "unit_id" }, "First Name:", -1))
const _hoisted_52 = {
  key: 1,
  class: "form-field"
}
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "unit_id" }, "Middle initial:", -1))
const _hoisted_54 = { class: "form-field" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "unit_id" }, "Last Name:", -1))
const _hoisted_56 = { class: "form-field" }
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "unit_id" }, "Email:", -1))
const _hoisted_58 = { class: "form-field" }
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "unit_id" }, "Phone Number:", -1))
const _hoisted_60 = ["onUpdate:modelValue"]
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { selected: "" }, "Mobile", -1))
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "Home", -1))
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "Work", -1))
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "Fax", -1))
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "Pager", -1))
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "Other", -1))
const _hoisted_67 = [
  _hoisted_61,
  _hoisted_62,
  _hoisted_63,
  _hoisted_64,
  _hoisted_65,
  _hoisted_66
]
const _hoisted_68 = ["onUpdate:modelValue"]
const _hoisted_69 = ["onUpdate:modelValue"]
const _hoisted_70 = ["onClick"]
const _hoisted_71 = { class: "form-field" }
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "address_line_1" }, "Address line 1:", -1))
const _hoisted_73 = { class: "form-field" }
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "address_line_2" }, "Address line 2:", -1))
const _hoisted_75 = { class: "form-field" }
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "city" }, "City:", -1))
const _hoisted_77 = { class: "form-field" }
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "state" }, "State/Province:", -1))
const _hoisted_79 = { class: "form-field" }
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "postal" }, "Postal:", -1))
const _hoisted_81 = { key: 3 }
const _hoisted_82 = {
  key: 0,
  class: "cost-section"
}
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { colspan: "2" }, "Due at Move-In", -1))
const _hoisted_84 = [
  _hoisted_83
]
const _hoisted_85 = {
  key: 0,
  class: "cost-note"
}
const _hoisted_86 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { colspan: "2" }, "Amounts above are before tax.", -1))
const _hoisted_87 = [
  _hoisted_86
]
const _hoisted_88 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Move In Subtotal", -1))
const _hoisted_89 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Move In Taxes", -1))
const _hoisted_90 = { key: 2 }
const _hoisted_91 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Convenience Fee", -1))
const _hoisted_92 = { key: 3 }
const _hoisted_93 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Previously Missed Fee", -1))
const _hoisted_94 = { key: 4 }
const _hoisted_95 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Fee(s) Total", -1))
const _hoisted_96 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Move In Total", -1))
const _hoisted_97 = { key: 0 }
const _hoisted_98 = { key: 1 }
const _hoisted_99 = { key: 5 }
const _hoisted_100 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "First Month Rent Subtotal", -1))
const _hoisted_101 = {
  key: 6,
  class: "cost-section"
}
const _hoisted_102 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { colspan: "2" }, "Ongoing Monthly", -1))
const _hoisted_103 = [
  _hoisted_102
]
const _hoisted_104 = { key: 7 }
const _hoisted_105 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Total Monthly Billing Amount", -1))
const _hoisted_106 = { key: 4 }
const _hoisted_107 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "forms" }, "Create Lease Form", -1))
const _hoisted_108 = ["value"]
const _hoisted_109 = {
  key: 0,
  class: "payment-link"
}
const _hoisted_110 = /*#__PURE__*/_createTextVNode(" Rental successful! Here is the ")
const _hoisted_111 = ["href"]
const _hoisted_112 = { class: "form-field" }
const _hoisted_113 = ["disabled"]
const _hoisted_114 = {
  key: 0,
  class: "col"
}
const _hoisted_115 = /*#__PURE__*/_createTextVNode(" Renting Unit ")
const _hoisted_116 = {
  key: 1,
  class: "col"
}

import serverMessage from "@/methods/server_message";
import { ref, watch, onMounted } from "vue";
import moment from "moment";
import BaseSpinner from "@/components/BaseSpinner.vue";
import OutstandingFeeBanner from "@/components/OutstandingFeeBanner.vue";
import { paymentAccountInterface } from "@/types/customers";

import Payment from "@/components/Payment.vue";

import api from "@virgodev/bazaar/functions/api";
import { UnitTypeInterface } from "@/types/unit";
import {
  InvoiceableInterface,
  ServiceInterface,
  InvoiceItemInterface,
} from "@/types/customers";
import InvoicesFees from "./InvoicesFees.vue";

import { UnitInterface } from "@/types/unit";
import { storeToRefs } from "pinia";
import { useStore } from "../../store";
import { useRouter, useRoute } from "vue-router";

export default /*#__PURE__*/_defineComponent({
  props: {
  customerId: {
    type: String,
    required: false,
    default: null,
  },
  unitId: {
    type: String,
    required: false,
    default: null,
  },
  unitType: {
    type: String,
    required: false,
    default: null,
  },
  unitStatus: {
    type: String,
    required: false,
    default: "available",
  },
  reservationId: {
    type: String,
    required: false,
    default: null,
  },
  facilityId: {
    type: String,
    default: null,
  },
},
  setup(__props) {

const props = __props

// import { useRouter } from "vue-router";
const store = useStore();
const { userData } = storeToRefs(store);
const api_settings = userData.value.chosenFacility.api_settings;

const isCcStorage = (userData.value.chosenFacility.api_name || "")
  .toLowerCase()
  .replace(/[-_ ]/g, "")
  .includes("ccstorage");

const convenienceFeeSetting =
  userData.value.chosenFacility.require_convenience_fee;
const convenienceFeeAmount = ref(0.0);
// Previously-missed convenience fee for this customer (from OutstandingFeeBanner);
// folded into the charge by the backend and into the move-in total below.
const missedFeeAmount = ref(0);
const chosenSavedCard = ref({});

const forms = ref();
const anniversary = ref(false);
const formSelected = ref();
const status = ref("loading");
const amountRented = ref();
const unitTypes = ref(Array<UnitTypeInterface>());
const selectedUnitType = ref();
const selectedUnit = ref();
// const selectedTaxRate = ref();
// const selectedFeeTaxRate = ref();
const errors = ref("");
const quote = ref();
const quoteError = ref("");

const customPrice = ref(false);
const formSubmitting = ref(false);
const customAmount = ref(null);
const insurances = ref();
const selectedCustomer = ref();
const units = ref();
const paymentLink = ref();
const filteredUnits = ref();

const feesAndProducts = ref(Array<InvoiceableInterface>());
const totalFeesProducts = ref(0);
const errorPaymentMessage = ref("");
const router = useRouter();
const route = useRoute();
const discountPlans = ref();
const hideGateAccessCode = ref(false);
const paymentAccounts = ref(Array<paymentAccountInterface>());
const urlForAuth = ref("");
const tokenFee = ref();
const availableAccount = ref();
// const billingOptions = ref([0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]);
const formErrors = ref<Record<string, string[]>>({});
const formFields = ref({
  form_id: ref(),
  waiting_id: ref(),
  quote: ref(),
  tax_exempt: ref(),
  move_in: {
    move_in_date: moment().format("YYYY-MM-DD"),
    should_generate_documents: ref(true),
    tenant_id: ref(props.customerId),
    lead_id: ref(),

    gate_access_code: ref(null),
    unit_id: ref(),
    invoice_period: "monthly",
    insurance_id: ref(null),
    services: ref(Array<ServiceInterface>()),
    invoiceable_items: ref(Array<InvoiceItemInterface>()),

    discount_plans: [
      {
        discount_plan_id: ref(null),
      },
    ],
  },
  payment_method: {
    payment_method_id: ref(),
    kind: ref(),
    autopay_enabled: ref(),
    reuseable: ref(),
    routing_number: ref(),
    account_number: ref(),
    verification_value: ref(),
    account_type: ref(),
    city: ref(),
    address: ref(),
    state: ref(),
    zip: ref(),
    card_number: ref(),
    expiration_date: ref(),
  },

  alternate_contact: {
    id: ref(null),
    description: ref(null),
    declined: ref(null),
    first_name: ref(null),
    middle_initial: ref(null),
    last_name: ref(null),
    email: ref(null),
    phone_numbers_attributes: [
      {
        id: ref(null),
        number: ref(null),
        extension: ref(null),
        label: ref(null),
        primary: ref(null),
      },
    ],
    address_attributes: {
      address1: ref(null),
      address2: ref(null),
      city: ref(null),
      state: ref(null),
      postal: ref(null),
    },
  },
  contact: {},
});
onMounted(async () => {
  if (
    userData.value.chosenFacility.storedge_invoice_period_set_to_anniversary
  ) {
    formFields.value.move_in.invoice_period = "anniversary";
    anniversary.value = true;
  }
  await getUnits();
  await getUnitTypes();
  if (props.customerId) {
    await getCustomer();
    // await getRentals();
  }
  if (api_settings.forms_with_rental) {
    await getForms();
  } else {
    getTenantPortalSettings();
  }
  status.value = "completed";
  if (props.unitId) {
    formFields.value.move_in.unit_id = props.unitId;
    if (units.value) {
      let unit: UnitInterface;

      if (props.unitStatus == "reserved") {
        unit = units.value;
      } else {
        unit = units.value.filter(
          (item: UnitInterface) => item.id == props.unitId
        )[0];
      }

      if (unit) {
        // formFields.value.move_in.unit_group_id = unit.unit_group_id;
        selectedUnitType.value = unitTypes.value.filter(
          (item) => item.id == unit.unit_group_id.toString()
        )[0];
        selectedUnit.value = unit;
        await updateForm();
      }
    }
  }
  if (props.unitType && !selectedUnitType.value) {
    selectedUnitType.value = unitTypes.value.filter(
      (item) => item.id == props.unitType
    )[0];
  }

  getInsurances();
  getDiscountPlans();
});
async function getTenantPortalSettings() {
  let response = await api({
    url: `get_tenant_portal_settings/?facilityId=${props.facilityId}`,
  });
  if (response.status == 200) {
    hideGateAccessCode.value =
      response.body.tenant_portal_settings.auto_generate_gate_code;
  }
}
async function getInsurances() {
  errors.value = "";
  const response = await api({
    url: `insurances/?facilityId=${props.facilityId}`,
  });
  if (response.status == 200) {
    if (response.body.invoiceable_items) {
      insurances.value = response.body.invoiceable_items;
    } else {
      insurances.value = response.body;
    }
  } else {
    errors.value =
      "Unable to communicate with the server. Please check your " +
      "connection and try again.";
  }
}
async function getDiscountPlans() {
  errors.value = "";
  let url = `discount_plans/?facilityId=${props.facilityId}`;
  if (api_settings.unit_id_with_discounts && selectedUnitType.value) {
    url += `&unitType=${selectedUnitType.value.id}`;
  }

  const response = await api({
    url: url,
  });
  if (response.status == 200) {
    if (response.body.discount_plans) {
      discountPlans.value = response.body.discount_plans;
    } else {
      discountPlans.value = response.body;
    }
  } else {
    errors.value =
      "Unable to communicate with the server. Please check your " +
      "connection and try again.";
  }
}

watch(selectedUnitType, () => {
  if (units.value && props.unitStatus != "reserved" && selectedUnitType.value) {
    filteredUnits.value = units.value.filter(
      (item: UnitInterface) => item.unit_group_id == selectedUnitType.value.id
    );
    if (!props.unitId) {
      selectedUnit.value = null;
    }
    if (api_settings.unit_id_with_discounts) {
      getDiscountPlans();
    }
  }
});
watch(amountRented, () => {
  if (amountRented.value == "custom") {
    customPrice.value = true;
  } else {
    customPrice.value = false;
  }
});

watch(feesAndProducts.value, () => {
  getQuote();
});
function addPaymentMethod(e: paymentAccountInterface) {
  formFields.value.payment_method = e.payment_method;
}
function updateFeesAndProducts(e: InvoiceableInterface) {
  if (e.service_id) {
    formFields.value.move_in.services.push({ service_id: e.service_id });
  } else {
    let item;
    if (api_settings.details_in_invoice) {
      item = {
        id: e.id,
        quantity: e.quantity,
        description: e.description,
        amount: e.amount,
      };
    } else {
      item = {
        id: e.id,
        quantity: e.quantity,
      };
    }
    formFields.value.move_in.invoiceable_items.push(item);
  }
  feesAndProducts.value.push(e);

  totalFeesProducts.value += Number(e.amount);
}
function removeFee(obj: InvoiceableInterface) {
  feesAndProducts.value.splice(
    feesAndProducts.value.indexOf(
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      feesAndProducts.value.find((item) => item == obj)
    ),
    1
  );
  if (obj.service_id) {
    formFields.value.move_in.services.splice(
      formFields.value.move_in.services.indexOf(
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        formFields.value.move_in.services.find(
          (item) => item.service_id == obj.service_id
        )
      ),
      1
    );
  } else if (obj.id) {
    formFields.value.move_in.invoiceable_items.splice(
      formFields.value.move_in.invoiceable_items.indexOf(
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        formFields.value.move_in.invoiceable_items.find(
          (item) => item.id == obj.id
        )
      ),
      1
    );
  }

  if (totalFeesProducts.value) {
    totalFeesProducts.value -= Number(obj.amount);
  }
}
function addContactNumber() {
  formFields.value.alternate_contact.phone_numbers_attributes.push({
    id: null,
    number: null,
    extension: null,
    label: null,
    primary: null,
  });
}
function removeContactNumber(obj: {
  id: null;
  number: null;
  extension: null;
  label: null;
}) {
  let index =
    formFields.value.alternate_contact.phone_numbers_attributes.findIndex(
      function (item) {
        return item === obj;
      }
    );

  if (index != -1) {
    formFields.value.alternate_contact.phone_numbers_attributes.splice(
      index,
      1
    );
  }
}

// function protectionPlan() {
//   return Number(
//     tenantProtectionPlans.value.filter(
//       (item: TenantProtectionPlanInterface) =>
//         item.id == formFields.value.available_tenant_protection_plan_id
//     )[0]
//   );
// }
// function protectionPlanTax() {
//   return (
//     (Number(selectedTaxRate.value.value_as_percentage) / 100) * protectionPlan()
//   );
// }
async function getCustomer() {
  errors.value = "";
  const response = await api({
    url: `customers/?id=${props.customerId}&facilityId=${props.facilityId}&include=contact`,
  });
  if (response.status == 200) {
    if (api_settings.extra_contact_info) {
      selectedCustomer.value = response.body.tenant;
      if (response.body.contact) {
        selectedCustomer.value.contact_info = response.body.contact;
      }
    } else {
      selectedCustomer.value = response.body[0];
    }
  } else {
    errors.value =
      "Unable to communicate with the server. Please check your " +
      "connection and try again.";
  }
}

async function getUnits() {
  let pagination = "";
  const responseData = await api({
    url: `units/?facilityId=${props.facilityId}&status=available&include=meta`,
  });
  if (responseData.status == 200) {
    if (
      responseData.body.meta &&
      responseData.body.meta.pagination.total_entries
    ) {
      pagination = responseData.body.meta.pagination.total_entries;
    }
  }
  let url = `units/?status=available&facilityId=${props.facilityId}&per_page=${pagination}`;

  if (props.unitStatus == "reserved") {
    url = `units/?id=${props.unitId}&facilityId=${props.facilityId}`;
  }

  errors.value = "";

  const response = await api({
    url,
  });

  if (response.status == 200) {
    if (props.unitStatus == "reserved") {
      units.value = response.body[0];
      filteredUnits.value = [units.value];
      selectedUnit.value = units.value;
    } else {
      units.value = response.body;
    }
  } else {
    errors.value =
      "Unable to communicate with the server. Please check your " +
      "connection and try again.";
  }
}

function updateForm() {
  if (selectedUnitType.value) {
    amountRented.value = selectedUnitType.value.price;
    if (selectedUnit.value) {
      formFields.value.move_in.unit_id = selectedUnit.value.id;
      getQuote();
    }
  }
}

async function getUnitTypes() {
  errors.value = "";
  const response = await api({
    url: `unit_types/?facilityId=${props.facilityId}`,
  });
  if (response.status == 200) {
    unitTypes.value = response.body;
    if (api_settings.unit_counts) {
      unitTypes.value = unitTypes.value.filter(
        (item) => Number(item.available_units_count) > 0
      );
    }

    // await getTaxRates();

    selectedUnitType.value = unitTypes.value[0];
    updateForm();
  } else {
    errors.value =
      "Unable to communicate with the server. Please check your " +
      "connection and try again.";
  }
}
async function getJson() {
  if (api_settings.pass_quote_with_rental && quote.value) {
    formFields.value.quote = quote.value;
  }
  if (api_settings.reservation_move_ins && props.unitStatus == "reserved") {
    formFields.value.waiting_id = props.reservationId;
  } else if (props.unitStatus == "reserved") {
    formFields.value.move_in.lead_id = props.reservationId;
  }
  const json = JSON.parse(JSON.stringify(formFields.value));
  // submitForm drops payment_method entirely when the agent entered none (a
  // move-in without payment is allowed wherever require_payment_with_rental is
  // off). Without this the next line threw and the rental was never sent — the
  // agent clicked Rent Unit and nothing happened at all.
  if (!json.payment_method) {
    json.payment_method = {};
  }
  if (!json.payment_method.payment_method_id) {
    delete json.payment_method.payment_method_id;
  }
  if (!json.payment_method.reuseable) {
    delete json.payment_method.reuseable;
  }
  if (!json.payment_method.routing_number) {
    delete json.payment_method.routing_number;
  }
  if (!json.payment_method.account_number) {
    delete json.payment_method.account_number;
  }
  if (!json.payment_method.verification_value) {
    delete json.payment_method.verification_value;
  }
  if (!json.payment_method.account_type) {
    delete json.payment_method.account_type;
  }
  if (!json.payment_method.city) {
    delete json.payment_method.city;
  }
  if (!json.payment_method.address) {
    delete json.payment_method.address;
  }
  if (!json.payment_method.state) {
    delete json.payment_method.state;
  }
  if (!json.payment_method.zip) {
    delete json.payment_method.zip;
  }
  if (!json.payment_method.card_number) {
    delete json.payment_method.card_number;
  }
  if (!json.payment_method.expiration_date) {
    delete json.payment_method.expiration_date;
  }
  if (
    json.move_in.services.length == 0 ||
    (json.move_in.services.length == 1 && !json.move_in.services[0].service_id)
  ) {
    delete json.move_in.services;
  }
  if (
    json.move_in.invoiceable_items.length == 0 ||
    (json.move_in.invoiceable_items.length == 1 &&
      !json.move_in.invoiceable_items[0].id)
  ) {
    delete json.move_in.invoiceable_items;
  }

  return json;
}

async function getQuote() {
  if (!formFields.value.move_in.unit_id) {
    quote.value = null;
    quoteError.value = "";
    return;
  }
  const json = await getJson();

  let url = `quote/?facilityId=${props.facilityId}`;

  const responseData = await api({
    url,
    method: "POST",
    json,
  });
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  if ([200, 201].includes(responseData.status)) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    if (responseData.body.move_in_unit_event) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      quote.value = responseData.body.move_in_unit_event;
    } else {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      quote.value = responseData.body;
    }
    if (convenienceFeeSetting && quote.value.move_in_total) {
      convenienceFeeAmount.value = (quote.value.move_in_total / 100) * 4;
    }
    quoteError.value = "";
  } else {
    // A refused quote used to be swallowed, leaving no costs and no reason —
    // and the move-in would then fail for the same reason at submit time.
    quote.value = null;
    quoteError.value = serverMessage(
      responseData,
      "The move-in cost could not be calculated for this unit. Check the " +
        "unit, rate and move-in date, or try again."
    );
  }
}

async function getConvenienceFeeToken() {
  let method;
  let payment_information;
  if (Object.keys(chosenSavedCard.value).length) {
    method = null;
  } else if (formFields.value.payment_method.card_number) {
    method = formFields.value.payment_method;
    let card_exp = method.expiration_date.split("/");
    payment_information = {
      card: {
        name:
          selectedCustomer.value.first_name +
          " " +
          selectedCustomer.value.last_name,
        number: method.card_number,
        expMonth: card_exp[0],
        address: {
          postalCode: method.zip,
          country: "US",
          region: method.state,
          streetAddress: method.address,
          city: method.city,
        },
        expYear: "20" + card_exp[1],
        cvc: method.verification_value,
      },
    };
  } else {
    method = formFields.value.payment_method;
    let accountType = method.account_type;
    if (accountType) {
      if (accountType == "checking") {
        accountType = "PERSONAL_CHECKING";
      } else if (accountType == "savings") {
        accountType = "PERSONAL_SAVINGS";
      } else {
        accountType = "BUSINESS_CHECKING";
      }
    }
    payment_information = {
      bankAccount: {
        name: selectedCustomer.value.first_name,
        accountNumber: method.account_number,
        accountType: accountType,
        phone: selectedCustomer.value.phone_numbers[0].unformatted_number,
        routingNumber: method.routing_number,
      },
    };
  }
  if (method) {
    const json = JSON.parse(JSON.stringify(payment_information));
    let url = `generate_token_convenience_fee/?facilityId=${props.facilityId}&id=${props.customerId}`;
    const responseData = await api({
      url,
      method: "POST",
      json,
    });
    if ([200, 201].includes(responseData.status)) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      tokenFee.value = responseData.body.value;
    }
  }
}
async function convenienceFee() {
  await getConvenienceFeeToken();

  const json = JSON.parse(
    JSON.stringify({
      token: tokenFee.value,
      chosen_saved_payment: chosenSavedCard.value,
      payment_method: formFields.value.payment_method.kind,
      save_payment: formFields.value.payment_method.reuseable,
      total_amount: convenienceFeeAmount.value.toFixed(2),
      tenant: {
        name:
          selectedCustomer.value.first_name +
          " " +
          selectedCustomer.value.last_name,
        id: props.customerId,
      },
    })
  );

  let url = `convenience_fee/?facilityId=${props.facilityId}&id=${props.customerId}`;
  const responseData = await api({
    url,
    method: "POST",
    json,
  });
  if ([200, 201].includes(responseData.status)) {
    console.log("Successful convenience fee");
  } else if (responseData.status == 409) {
    if (
      responseData.body.errors &&
      responseData.body.errors[0].message.includes("Card already exists.")
    ) {
      await quickBooksAuthCheck();
    }
  } else if (responseData.status === 400 || responseData.status === 406) {
    formErrors.value = responseData.body;
    errorPaymentMessage.value = responseData.body.errors;
  } else {
    formErrors.value = {
      non_field_errors: [
        "Unable to communicate with the server. Please check your " +
          "connection and try again.",
      ],
    };
  }
}
async function quickBooksAuthCheck() {
  let url = `auth_check/?facilityId=${props.facilityId}&id=${props.customerId}`;
  const responseData = await api({
    url,
    method: "GET",
  });
  if ([200, 201].includes(responseData.status)) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    if (responseData.body.url) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      urlForAuth.value = responseData.body.url;
    } else {
      await convenienceFee();
    }
  } else if (responseData.status === 400 || responseData.status === 406) {
    formErrors.value = responseData.body;
    errorPaymentMessage.value = responseData.body.errors;
  } else {
    formErrors.value = {
      non_field_errors: [
        "Unable to communicate with the server. Please check your " +
          "connection and try again.",
      ],
    };
  }
}
async function getPaymentAccounts() {
  errors.value = "";
  let id = props.customerId;
  if (api_settings.use_contact_id) {
    id = selectedCustomer.value.contact_id;
  }
  const response = await api({
    url: `payment_accounts/?id=${id}&facilityId=${props.facilityId}`,
  });
  if (response.status == 200) {
    paymentAccounts.value = response.body;
    if (api_settings.filter_payment_accounts) {
      paymentAccounts.value = response.body.filter(
        (item: { account: number; card_number: number }) =>
          item.account || item.card_number
      );
    }
    if (formFields.value.payment_method.payment_method_id) {
      chosenSavedCard.value = paymentAccounts.value.filter(
        (item: { id: string }) =>
          item.id == formFields.value.payment_method.payment_method_id
      )[0];
    } else {
      let foundAvailable = false;
      let allAccounts = response.body;
      if (
        allAccounts &&
        api_settings.get_available_account &&
        formFields.value.payment_method.reuseable
      ) {
        for (let account of allAccounts) {
          if (!account.account_or_card_number) {
            availableAccount.value = account;
            foundAvailable = true;
            break;
          }
        }
        if (!foundAvailable) {
          availableAccount.value = allAccounts[0];
        }
      }
    }
  } else {
    errors.value =
      "Unable to communicate with the server. Please check your " +
      "connection and try again.";
  }
}

async function getForms() {
  errors.value = "";
  const response = await api({
    url: `forms/?facilityId=${props.facilityId}`,
  });
  if (response.status == 200) {
    forms.value = response.body;
  } else {
    errors.value =
      "Unable to communicate with the server. Please check your " +
      "connection and try again.";
  }
}
async function sendEsign(event_id: string) {
  errors.value = "";
  let phoneNumber = "";
  if (selectedCustomer.value.phone_numbers.length > 0) {
    phoneNumber = selectedCustomer.value.phone_numbers[0].number;
  }
  const response = await api({
    url: `send_esign/?facilityId=${props.facilityId}&event_id=${event_id}`,
    method: "POST",
    json: {
      email: selectedCustomer.value.email,
      sms: phoneNumber,
    },
  });
  if (response.status == 200) {
    console.log("ESIGN sent");
  } else {
    errors.value =
      "Unable to communicate with the server. Please check your " +
      "connection and try again.";
  }
}
async function submitForm() {
  if (
    !formFields.value.payment_method.payment_method_id &&
    !formFields.value.payment_method.kind
  ) {
    if (formFields.value.payment_method) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      delete formFields.value.payment_method;
    }
  }
  if (api_settings.forms_with_rental) {
    formFields.value.form_id = formSelected.value;
  }
  if (api_settings.tax_exempt_rental) {
    formFields.value.tax_exempt = false;
  } else {
    delete formFields.value.tax_exempt;
  }
  if (api_settings.use_lead_id_with_reserve) {
    formFields.value.contact = selectedCustomer.value.contact_info["contact"];
  } else {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    delete formFields.value.contact;
  }
  formErrors.value = {};
  formSubmitting.value = true;

  // Anything that throws while the request is being built or sent has to end
  // up on screen: an agent who clicks Rent Unit and sees nothing cannot tell a
  // failure from a slow response, and may rent the unit twice.
  let responseData;
  try {
    const json = await getJson();

    let url = `create_rental/?facilityId=${props.facilityId}&unit_status=${props.unitStatus}`;
    if (api_settings.total_amount_required) {
      if (!quote.value) {
        formSubmitting.value = false;
        formErrors.value = {
          server_error: [
            "The unit was not rented: the move-in cost has not been " +
              "calculated yet. Check the unit, rate and move-in date above.",
          ],
        };
        return;
      }
      url += `&total_amount=${quote.value.move_in_total}`;
    }
    const method: "POST" | "PATCH" = "POST";

    responseData = await api({
      url,
      method,
      json,
    });
  } catch (exception) {
    formSubmitting.value = false;
    formErrors.value = {
      server_error: [
        "The unit was not rented — the move-in could not be sent. Nothing " +
          "was charged. Check the form and try again.",
      ],
    };
    // eslint-disable-next-line no-console
    console.error("Move-in request failed before it was sent", exception);
    return;
  }

  formSubmitting.value = false;
  if ([200, 201].includes(responseData.status)) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    if (responseData.body.move_in_unit_event) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      await sendEsign(responseData.body.move_in_unit_event.id);
    }
    if (convenienceFeeSetting) {
      if (formFields.value.payment_method.payment_method_id) {
        await getPaymentAccounts();
      }
      if (formFields.value.payment_method.kind != "check") {
        await quickBooksAuthCheck();
      }
      if (
        formFields.value.payment_method.reuseable &&
        api_settings.get_available_account
      ) {
        await getPaymentAccounts();
        saveAccount();
      }
    }
    if (
      formFields.value.payment_method &&
      formFields.value.payment_method.autopay_enabled &&
      !api_settings.saving_resusable_card
    ) {
      const json = JSON.parse(JSON.stringify(formFields.value));
      errors.value = "";
      await api({
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        url: `ledgers_autopay/?id=${responseData.body[0].Ret_Code}&facilityId=${props.facilityId}`,
        method: "PUT",
        json,
      });
    }
    if (
      api_settings.payment_link &&
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      responseData.body.data &&
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      responseData.body.data.paymentLink
    ) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      paymentLink.value = responseData.body.data.paymentLink;
    } else {
      router.push(
        typeof route.query.next === "string"
          ? route.query.next
          : {
              name: "customer_detail_storedge",
              params: {
                id: props.customerId,
                facilityId: props.facilityId,
              },
            }
      );
    }
  } else if (responseData.status === 400) {
    formErrors.value = {
      server_error: [
        serverMessage(
          responseData,
          "The unit was not rented. The facility's system rejected the " +
            "move-in — check the unit, rate, move-in date and payment details, " +
            "then try again."
        ),
      ],
    };
  } else {
    // Anything else (403 / 404 / 409 / 500 / 501 ...): say the rental did not
    // go through, and pass along whatever the server did tell us.
    formErrors.value = {
      server_error: [
        serverMessage(
          responseData,
          `The unit was not rented (error ${responseData.status}). Nothing ` +
            "was charged. Try again, and if it keeps happening this facility's " +
            "API connection may need attention."
        ),
      ],
    };
  }
}
async function saveAccount() {
  const json = JSON.parse(JSON.stringify(formFields.value));
  let url = `payment_accounts/?facilityId=${props.facilityId}&id=${availableAccount.value.id}`;
  const responseData = await api({
    url,
    method: "POST",
    json,
  });
  if ([200, 201].includes(responseData.status)) {
    console.log("Successfully saved account");
  } else if (responseData.status === 400 || responseData.status === 406) {
    formErrors.value = responseData.body;
  } else {
    formErrors.value = {
      non_field_errors: [
        "Unable to communicate with the server. Please check your " +
          "connection and try again.",
      ],
    };
  }
}

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_BaseAlert = _resolveComponent("BaseAlert")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (__props.customerId && selectedCustomer.value)
      ? (_openBlock(), _createBlock(_component_RouterLink, {
          key: 0,
          to: {
      name: 'customer_detail_storedge',
      params: { id: __props.customerId, facilityId: __props.facilityId },
    }
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Back to Customer: " + _toDisplayString(selectedCustomer.value.first_name) + " " + _toDisplayString(selectedCustomer.value.last_name), 1)
          ]),
          _: 1
        }, 8, ["to"]))
      : _createCommentVNode("", true),
    _createVNode(OutstandingFeeBanner, {
      "facility-id": __props.facilityId,
      "customer-id": __props.customerId,
      onTotal: _cache[0] || (_cache[0] = ($event: any) => (missedFeeAmount.value = $event))
    }, null, 8, ["facility-id", "customer-id"]),
    (formErrors.value.non_field_errors !== undefined)
      ? (_openBlock(), _createBlock(_component_BaseAlert, {
          key: 1,
          variant: "danger",
          class: "js-form-error",
          dismissible: "",
          onDismissed: _cache[1] || (_cache[1] = ($event: any) => (formErrors.value = {}))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(formErrors.value.non_field_errors[0]), 1)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _hoisted_1,
    _createElementVNode("form", {
      class: "large-width-centered",
      onSubmit: _withModifiers(submitForm, ["prevent"])
    }, [
      _createElementVNode("fieldset", null, [
        (status.value === 'loading')
          ? (_openBlock(), _createBlock(BaseSpinner, {
              key: 0,
              preset: "large"
            }))
          : _createCommentVNode("", true),
        (status.value == 'completed')
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              (selectedCustomer.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _hoisted_5,
                    _createElementVNode("input", {
                      value: 
              selectedCustomer.value.first_name + ' ' + selectedCustomer.value.last_name
            ,
                      type: "text",
                      disabled: ""
                    }, null, 8, _hoisted_6)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_7, [
                _hoisted_8,
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((selectedUnitType).value = $event)),
                  required: "",
                  class: "form-select"
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(unitTypes.value, (typeOfUnit) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: typeOfUnit + 'id',
                      value: typeOfUnit,
                      disabled: __props.unitStatus == 'reserved'
                    }, [
                      _createTextVNode(_toDisplayString(typeOfUnit.size) + " ", 1),
                      (typeOfUnit.description)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createTextVNode(_toDisplayString(typeOfUnit.description), 1)
                          ], 64))
                        : _createCommentVNode("", true)
                    ], 8, _hoisted_9))
                  }), 128))
                ], 512), [
                  [_vModelSelect, selectedUnitType.value]
                ])
              ]),
              (filteredUnits.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    _hoisted_11,
                    (filteredUnits.value == 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_12, " No units available for this unit type. Reselect another unit type. "))
                      : _createCommentVNode("", true),
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((selectedUnit).value = $event)),
                      required: "",
                      class: "form-select",
                      disabled: __props.unitStatus == 'reserved',
                      onChange: _cache[4] || (_cache[4] = ($event: any) => (updateForm()))
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredUnits.value, (unit) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: unit + 'id',
                          value: unit
                        }, _toDisplayString(unit.name), 9, _hoisted_14))
                      }), 128))
                    ], 40, _hoisted_13), [
                      [_vModelSelect, selectedUnit.value]
                    ])
                  ]))
                : _createCommentVNode("", true),
              (selectedUnitType.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                    _hoisted_16,
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((amountRented).value = $event)),
                      class: "form-select",
                      required: "",
                      onChange: _cache[6] || (_cache[6] = ($event: any) => (getQuote()))
                    }, [
                      _createElementVNode("option", {
                        value: selectedUnitType.value.price
                      }, " $ " + _toDisplayString(selectedUnitType.value.price) + " per month ", 9, _hoisted_17)
                    ], 544), [
                      [_vModelSelect, amountRented.value]
                    ])
                  ]))
                : _createCommentVNode("", true),
              (customPrice.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                    _createElementVNode("div", _hoisted_19, [
                      _hoisted_20,
                      _hoisted_21,
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((customAmount).value = $event)),
                        type: "decimal",
                        step: ".01",
                        required: "",
                        onChange: _cache[8] || (_cache[8] = ($event: any) => (getQuote()))
                      }, null, 544), [
                        [_vModelText, customAmount.value]
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (discountPlans.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                    _hoisted_23,
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((formFields.value.move_in.discount_plans[0].discount_plan_id) = $event)),
                      class: "form-select",
                      onChange: _cache[10] || (_cache[10] = ($event: any) => (getQuote()))
                    }, [
                      _hoisted_24,
                      (!discountPlans.value.length)
                        ? (_openBlock(), _createElementBlock("option", _hoisted_25, " No discounts available "))
                        : _createCommentVNode("", true),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(discountPlans.value, (plan) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: plan.id + 'plan',
                          value: plan.id
                        }, _toDisplayString(plan.name), 9, _hoisted_26))
                      }), 128))
                    ], 544), [
                      [_vModelSelect, formFields.value.move_in.discount_plans[0].discount_plan_id]
                    ])
                  ]))
                : _createCommentVNode("", true),
              (hideGateAccessCode.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                    _hoisted_28,
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((formFields.value.move_in.gate_access_code) = $event)),
                      type: "text",
                      required: ""
                    }, null, 512), [
                      [_vModelText, formFields.value.move_in.gate_access_code]
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_unref(api_settings).allow_password)
                ? (_openBlock(), _createElementBlock("div", _hoisted_29, _hoisted_31))
                : _createCommentVNode("", true),
              (_unref(api_settings).invoice_period_on_rental_form)
                ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                    _hoisted_33,
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((formFields.value.move_in.invoice_period) = $event)),
                      class: "form-select",
                      onChange: _cache[13] || (_cache[13] = ($event: any) => (getQuote()))
                    }, [
                      _createElementVNode("option", _hoisted_34, [
                        _hoisted_35,
                        (!anniversary.value)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _hoisted_36
                            ], 64))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("option", _hoisted_37, [
                        _hoisted_38,
                        (anniversary.value)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _hoisted_39
                            ], 64))
                          : _createCommentVNode("", true)
                      ])
                    ], 544), [
                      [_vModelSelect, formFields.value.move_in.invoice_period]
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_40, [
                _hoisted_41,
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((formFields.value.move_in.insurance_id) = $event)),
                  class: "form-select",
                  onChange: _cache[15] || (_cache[15] = ($event: any) => (getQuote()))
                }, [
                  _hoisted_42,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(insurances.value, (insurance) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: insurance.id,
                      value: insurance.id
                    }, _toDisplayString(insurance.description) + " - $" + _toDisplayString(insurance.amount) + " per month ", 9, _hoisted_43))
                  }), 128))
                ], 544), [
                  [_vModelSelect, formFields.value.move_in.insurance_id]
                ])
              ]),
              (_unref(api_settings).show_fees_products)
                ? (_openBlock(), _createBlock(InvoicesFees, {
                    key: 8,
                    "customer-id": __props.customerId,
                    "facility-id": __props.facilityId,
                    onFeesAndProducts: updateFeesAndProducts
                  }, null, 8, ["customer-id", "facility-id"]))
                : _createCommentVNode("", true),
              _createElementVNode("table", null, [
                (feesAndProducts.value.length)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(feesAndProducts.value, (item) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: item.id + 'item'
                      }, [
                        _createElementVNode("td", null, _toDisplayString(item.description), 1),
                        _createElementVNode("td", null, "$" + _toDisplayString(item.amount), 1),
                        _createElementVNode("td", null, [
                          _createElementVNode("a", {
                            onClick: ($event: any) => (removeFee(item))
                          }, "remove", 8, _hoisted_44)
                        ])
                      ]))
                    }), 128))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_45, [
                _hoisted_46,
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((formFields.value.move_in.move_in_date) = $event)),
                  type: "date",
                  required: ""
                }, null, 512), [
                  [_vModelText, formFields.value.move_in.move_in_date]
                ])
              ]),
              (_unref(api_settings).alternate_contact_on_rental_form)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 9 }, [
                    _hoisted_47,
                    _createElementVNode("div", null, [
                      (_unref(api_settings).alternate_contact_description)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                            _hoisted_49,
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((formFields.value.alternate_contact.description) = $event)),
                              type: "text"
                            }, null, 512), [
                              [_vModelText, formFields.value.alternate_contact.description]
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_50, [
                        _hoisted_51,
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((formFields.value.alternate_contact.first_name) = $event)),
                          type: "text",
                          required: ""
                        }, null, 512), [
                          [_vModelText, formFields.value.alternate_contact.first_name]
                        ])
                      ]),
                      (_unref(api_settings).alternate_contact_middle_initial)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                            _hoisted_53,
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((formFields.value.alternate_contact.middle_initial) = $event)),
                              type: "text"
                            }, null, 512), [
                              [_vModelText, formFields.value.alternate_contact.middle_initial]
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_54, [
                        _hoisted_55,
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((formFields.value.alternate_contact.last_name) = $event)),
                          type: "text",
                          required: ""
                        }, null, 512), [
                          [_vModelText, formFields.value.alternate_contact.last_name]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_56, [
                        _hoisted_57,
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((formFields.value.alternate_contact.email) = $event)),
                          type: "text",
                          required: ""
                        }, null, 512), [
                          [_vModelText, formFields.value.alternate_contact.email]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_58, [
                        _hoisted_59,
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formFields.value.alternate_contact
                  .phone_numbers_attributes, (contact_number) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: contact_number.id + 'number',
                            class: "row"
                          }, [
                            (_unref(api_settings).alternate_contact_phone_label)
                              ? _withDirectives((_openBlock(), _createElementBlock("select", {
                                  key: 0,
                                  "onUpdate:modelValue": ($event: any) => ((contact_number.label) = $event),
                                  class: "form-select"
                                }, _hoisted_67, 8, _hoisted_60)), [
                                  [_vModelSelect, contact_number.label]
                                ])
                              : _createCommentVNode("", true),
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": ($event: any) => ((contact_number.number) = $event),
                              class: "form-field",
                              type: "text",
                              placeholder: "primary number",
                              required: ""
                            }, null, 8, _hoisted_68), [
                              [_vModelText, contact_number.number]
                            ]),
                            (_unref(api_settings).alternate_contact_phone_extension)
                              ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                  key: 1,
                                  "onUpdate:modelValue": ($event: any) => ((contact_number.extension) = $event),
                                  class: "form-field",
                                  type: "text",
                                  placeholder: "extension"
                                }, null, 8, _hoisted_69)), [
                                  [_vModelText, contact_number.extension]
                                ])
                              : _createCommentVNode("", true),
                            (
                    formFields.value.alternate_contact.phone_numbers_attributes
                      .length > 1
                  )
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: 2,
                                  class: "btn btn-text",
                                  onClick: ($event: any) => (removeContactNumber(contact_number))
                                }, " Remove ", 8, _hoisted_70))
                              : _createCommentVNode("", true)
                          ]))
                        }), 128))
                      ]),
                      (_unref(api_settings).alternate_contact_multiple)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 2,
                            class: "btn btn-text",
                            onClick: _cache[22] || (_cache[22] = ($event: any) => (addContactNumber()))
                          }, " Add number "))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_71, [
                        _hoisted_72,
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((
                  formFields.value.alternate_contact.address_attributes.address1
                ) = $event)),
                          type: "text",
                          required: ""
                        }, null, 512), [
                          [_vModelText, 
                  formFields.value.alternate_contact.address_attributes.address1
                ]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_73, [
                        _hoisted_74,
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((
                  formFields.value.alternate_contact.address_attributes.address2
                ) = $event)),
                          type: "text"
                        }, null, 512), [
                          [_vModelText, 
                  formFields.value.alternate_contact.address_attributes.address2
                ]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_75, [
                        _hoisted_76,
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((formFields.value.alternate_contact.address_attributes.city) = $event)),
                          type: "text",
                          required: ""
                        }, null, 512), [
                          [_vModelText, formFields.value.alternate_contact.address_attributes.city]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_77, [
                        _hoisted_78,
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((formFields.value.alternate_contact.address_attributes.state) = $event)),
                          type: "text",
                          required: ""
                        }, null, 512), [
                          [_vModelText, formFields.value.alternate_contact.address_attributes.state]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_79, [
                        _hoisted_80,
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((formFields.value.alternate_contact.address_attributes.postal) = $event)),
                          type: "text",
                          required: ""
                        }, null, 512), [
                          [_vModelText, formFields.value.alternate_contact.address_attributes.postal]
                        ])
                      ])
                    ])
                  ], 64))
                : _createCommentVNode("", true),
              _createElementVNode("div", null, [
                _createVNode(Payment, {
                  "facility-id": __props.facilityId,
                  "customer-id": __props.customerId,
                  onPaymentMethod: addPaymentMethod
                }, null, 8, ["facility-id", "customer-id"])
              ])
            ]))
          : _createCommentVNode("", true),
        (quoteError.value)
          ? (_openBlock(), _createBlock(_component_BaseAlert, {
              key: 2,
              variant: "danger",
              class: "js-form-error",
              dismissible: "",
              onDismissed: _cache[28] || (_cache[28] = ($event: any) => (quoteError.value = ''))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(quoteError.value), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (quote.value)
          ? (_openBlock(), _createElementBlock("table", _hoisted_81, [
              (_unref(isCcStorage))
                ? (_openBlock(), _createElementBlock("tr", _hoisted_82, _hoisted_84))
                : _createCommentVNode("", true),
              (quote.value.invoice_line_items.length)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(quote.value.invoice_line_items, (line) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: line.id + 'item'
                      }, [
                        _createElementVNode("td", null, [
                          _createTextVNode(_toDisplayString(line.description) + " ", 1),
                          (line.discount && Number(line.discount) > 0)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createTextVNode(" with $" + _toDisplayString(Number(line.discount).toFixed(2)) + " discount ", 1)
                              ], 64))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("td", null, "$" + _toDisplayString(Number(line.total).toFixed(2)), 1)
                      ]))
                    }), 128)),
                    (_unref(isCcStorage) && Number(quote.value.move_in_taxes_total) > 0)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_85, _hoisted_87))
                      : _createCommentVNode("", true)
                  ], 64))
                : _createCommentVNode("", true),
              _createElementVNode("tr", null, [
                _hoisted_88,
                _createElementVNode("td", null, "$" + _toDisplayString(Number(quote.value.move_in_subtotal).toFixed(2)), 1)
              ]),
              _createElementVNode("tr", null, [
                _hoisted_89,
                _createElementVNode("td", null, "$" + _toDisplayString(Number(quote.value.move_in_taxes_total).toFixed(2)), 1)
              ]),
              (_unref(convenienceFeeSetting))
                ? (_openBlock(), _createElementBlock("tr", _hoisted_90, [
                    _hoisted_91,
                    _createElementVNode("td", null, "$" + _toDisplayString(Number(convenienceFeeAmount.value).toFixed(2)), 1)
                  ]))
                : _createCommentVNode("", true),
              (_unref(convenienceFeeSetting) && missedFeeAmount.value > 0)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_92, [
                    _hoisted_93,
                    _createElementVNode("td", null, "$" + _toDisplayString(Number(missedFeeAmount.value).toFixed(2)), 1)
                  ]))
                : _createCommentVNode("", true),
              (
            _unref(api_settings).forms_with_rental &&
            formFields.value.move_in.invoiceable_items.length
          )
                ? (_openBlock(), _createElementBlock("tr", _hoisted_94, [
                    _hoisted_95,
                    _createElementVNode("td", null, "$" + _toDisplayString(Number(totalFeesProducts.value)), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("tr", null, [
                _hoisted_96,
                (
              _unref(api_settings).forms_with_rental &&
              formFields.value.move_in.invoiceable_items.length
            )
                  ? (_openBlock(), _createElementBlock("td", _hoisted_97, [
                      (_unref(convenienceFeeSetting))
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createTextVNode(" $" + _toDisplayString(Number(
                  quote.value.move_in_total +
                    Number(totalFeesProducts.value) +
                    Number(convenienceFeeAmount.value) +
                    Number(missedFeeAmount.value)
                ).toFixed(2)), 1)
                          ], 64))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createTextVNode(" $" + _toDisplayString(Number(quote.value.move_in_total + Number(totalFeesProducts.value)).toFixed(
                  2
                )), 1)
                          ], 64))
                    ]))
                  : (_openBlock(), _createElementBlock("td", _hoisted_98, [
                      (_unref(convenienceFeeSetting))
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createTextVNode("$" + _toDisplayString(Number(
                  Number(quote.value.move_in_total) +
                    Number(convenienceFeeAmount.value) +
                    Number(missedFeeAmount.value)
                ).toFixed(2)), 1)
                          ], 64))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createTextVNode("$" + _toDisplayString(Number(quote.value.move_in_total).toFixed(2)), 1)
                          ], 64))
                    ]))
              ]),
              (quote.value.first_month_rent_subtotal)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_99, [
                    _hoisted_100,
                    _createElementVNode("td", null, "$" + _toDisplayString(quote.value.first_month_rent_subtotal), 1)
                  ]))
                : _createCommentVNode("", true),
              (_unref(isCcStorage) && quote.value.total_monthly_billing_amount)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_101, _hoisted_103))
                : _createCommentVNode("", true),
              (quote.value.total_monthly_billing_amount)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_104, [
                    _hoisted_105,
                    _createElementVNode("td", null, "$" + _toDisplayString(Number(quote.value.total_monthly_billing_amount).toFixed(2)), 1)
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        (forms.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_106, [
              _hoisted_107,
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((formSelected).value = $event)),
                class: "form-select",
                required: ""
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(forms.value, (form) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: 'form' + form.FormID,
                    value: form.FormID
                  }, _toDisplayString(form.sDefFormName), 9, _hoisted_108))
                }), 128))
              ], 512), [
                [_vModelSelect, formSelected.value]
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      (paymentLink.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_109, [
            _hoisted_110,
            _createElementVNode("a", {
              href: paymentLink.value,
              target: "_blank"
            }, "Payment Link", 8, _hoisted_111)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_112, [
        _createElementVNode("button", {
          disabled: formSubmitting.value,
          type: "submit",
          class: "btn btn-text"
        }, [
          (formSubmitting.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_114, [
                _hoisted_115,
                _createVNode(BaseSpinner)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_116, "Rent Unit"))
        ], 8, _hoisted_113)
      ]),
      (formErrors.value.server_error !== undefined)
        ? (_openBlock(), _createBlock(_component_BaseAlert, {
            key: 1,
            variant: "danger",
            class: "js-form-error",
            dismissible: "",
            onDismissed: _cache[30] || (_cache[30] = ($event: any) => (formErrors.value = {}))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(formErrors.value.server_error[0]), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ], 40, _hoisted_2)
  ], 64))
}
}

})